/**
 * Krok MOB1 bod 2 — PRUH „Je k dispozici nová verze — Načíst".
 *
 * Zadani: nova verze se NABIDNE, neprepne se sama uprostred prace. Service
 * worker proto ceka (`sw.js` nevola `skipWaiting()` sam) a teprve klepnuti na
 * „Načíst" ho pusti dal a obrazovku nacte znovu (`applyUpdate` v `lib/pwa.ts`).
 *
 * Pruh zije NAD routerem (`main.tsx`), aby se ukazal na kazde obrazovce vcetne
 * prihlaseni — nova verze se muze objevit kdykoli, ne jen uvnitr shellu.
 */

import * as React from 'react';
import { applyUpdate, registerServiceWorker } from '../lib/pwa.js';
import { UPDATE_TEXTS } from '../lib/texts.js';

export function UpdateBanner(): React.JSX.Element {
  const [ready, setReady] = React.useState(false);

  React.useEffect(() => {
    void registerServiceWorker(() => { setReady(true); });
  }, []);

  /*
   * Priznak na `<html>`, aby si shell udelal pod pruhem misto (sazba v
   * `styles/ux-v4.css`). Pruh je `position: fixed` — bez toho by na mobilu
   * prekryl horni listu i tlacitko „Více" a uzivatel by se do nabidky
   * nedostal, dokud novou verzi nenacte.
   */
  React.useEffect(() => {
    if (!ready) return;
    document.documentElement.dataset['reosUpdate'] = 'true';
    return () => {
      delete document.documentElement.dataset['reosUpdate'];
    };
  }, [ready]);

  if (!ready) return <></>;

  return (
    <div
      role="status"
      data-testid="update-banner"
      className="rh-v4-update"
    >
      <span>{UPDATE_TEXTS.banner}</span>
      <button
        type="button"
        className="rh-btn rh-btn--primary"
        data-testid="update-reload"
        onClick={() => { applyUpdate(); }}
      >
        {UPDATE_TEXTS.action}
      </button>
      <button
        type="button"
        className="rh-btn"
        data-testid="update-dismiss"
        onClick={() => { setReady(false); }}
      >
        {UPDATE_TEXTS.dismiss}
      </button>
    </div>
  );
}
